/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  heading: {
    paddingTop: Tokens.spacing['$sp-3'],
    '&:first-child': {
      paddingTop: Tokens.spacing['$sp-1']
    }
  },
  valueRow: {
    paddingTop: Tokens.spacing['$sp-2']
  },
  value: {
    fontWeight: 500
  },
  accent: {
    fontWeight: 500,
    color: theme.palette.text.secondary
  },
  list: {
    listStyleType: 'disc',
    background: "transparent",
    padding: theme.spacing(0, 0, 0, 2.5)
  },
  listItem: {
    display: 'list-item',
    padding: 0,
  }
}));
